import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import JdbcReaderForm from '../forms/jdbc-reader-form';
import { jdbcReaderValidationSchema } from '../schema/jdbcReader.js';

export default function JdbcReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'JDBC Reader Node Details',
        altText: 'JDBC Reader Node',
        defaultLabel: 'JDBC Reader Node',
      }}
    >
      <CommonNode FormComponent={JdbcReaderForm} schemaResolver={jdbcReaderValidationSchema} />
    </NodeProvider>
  );
}
